import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Room = ({ room }) => {
    const { name, slug, images, price } = room;
    return (
        <article className="room">
            <div className="img-container">
                <img src={images[0]} alt="singleRoom" />
                <div className="price-top">
                    <h6>{price}</h6>
                    <p>Per Night</p>
                </div>
                <Link to={`/rooms/${slug}`} className="btn-primary room-link">Feature</Link>
            </div>
            <p className="room-info">{name}</p>
        </article>
    );
}

Room.propTypes = {
    room: PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        images: PropTypes.arrayOf(PropTypes.string).isRequired
    })
}

export default Room;
